export default __webpack_public_path__ + "static/media/köide-21-22.8e52fb81.png";